export default "__VITE_ASSET__7cJw89Wi__"